import React from "react";
import PropTypes from "prop-types";
import { getVoucherUpgradeDetails } from "@utils/ticketUtils";
import "./style.scss";

const BookedTicketSavings = ({ ticket, session }) => {
    const rawSavings = (ticket?.total_rrp_pricing || 0) - (ticket?.total_price_cents || 0);
    const ticketQuantity = ticket?.total_tickets || 0;
    const upgradeDetails = session ? getVoucherUpgradeDetails(session) : null;
    const upgradeFeePerTicket = Number(upgradeDetails?.fee) || 0;
    const upgradeFeeCents = upgradeDetails
        ? Math.round(upgradeFeePerTicket * 100) * ticketQuantity
        : (ticket?.upgrade_fee_cents || 0);

    const savings = rawSavings - upgradeFeeCents;
    const showUpgradeFee = upgradeFeeCents > 0;

    return (
        <div className="booked-ticket-savings">
            {savings > 0 ? (
                <div className="booked-ticket-savings__item booked-ticket-savings__item--savings">
                    You Saved: ${(savings / 100).toFixed(2)}
                    {upgradeFeePerTicket > 0 && (
                        <span className="booked-ticket-savings__note">
                            {" "}(after ${upgradeFeePerTicket.toFixed(2)} x {ticketQuantity} upgrade fee)
                        </span>
                    )}
                </div>
            ) : null}
            {showUpgradeFee && (
                <div className="booked-ticket-savings__item booked-ticket-savings__item--upgrade-fee">
                    Upgrade Fee: ${(upgradeFeeCents / 100).toFixed(2)}
                    {upgradeFeePerTicket > 0 && (
                        <span className="booked-ticket-savings__note">
                            {" "}(${upgradeFeePerTicket.toFixed(2)} x {ticketQuantity})
                        </span>
                    )}
                </div>
            )}
        </div>
    );
};

BookedTicketSavings.propTypes = {
    ticket: PropTypes.object,
    session: PropTypes.object,
};

export default BookedTicketSavings;
